<button><mat-icon svgIcon="chevron-right" tableIndex="-1"></mat-icon></button>
<span>
  <span class="label"> <ng-content select="group-field"></ng-content>: </span>
  <ng-content select="group-name"></ng-content>
</span>
